import { NgClass } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { EventTrackingService } from '@core/services/event-tracking.service';
import { EMatchingType } from '@enums/campaign-analytics.enum';
import { EPlatformFeature } from '@enums/campaign.enum';
import { EEventType } from '@enums/event-tracking.enum';
import { TranslateModule } from '@ngx-translate/core';
import { TimeagoModule } from 'ngx-timeago';
import { ICtaAnalyticsData } from '../../cta-analytics-table.interface';
import { CtaAnalyticsDetailsKpiCardComponent } from './cta-analytics-details-kpi-card/cta-analytics-details-kpi-card.component';
import { IKpiCard } from './cta-analytics-details-kpi-card/cta-analytics-details-kpi-card.interface';

@Component({
  imports: [CtaAnalyticsDetailsKpiCardComponent, MatButtonModule, NgClass, TimeagoModule, TranslateModule],
  selector: 'app-cta-analytics-details-kpis-tile',
  styleUrl: './cta-analytics-details-kpis-tile.component.scss',
  templateUrl: './cta-analytics-details-kpis-tile.component.html',
})
export class CtaAnalyticsDetailsKpisTileComponent {
  public readonly execution = input.required<ICtaAnalyticsData>();
  public readonly kpiCardData = input.required<IKpiCard[]>();
  public readonly platformFeature = input.required<EPlatformFeature>();
  /** True when rendered outside any campaign (e.g. the creator content dialog) — see #34/#62. */
  public readonly noCampaignContextMode = input<boolean>(false);
  public readonly creatorBriefingMode = input<boolean>(false);

  public readonly EMatchingType = EMatchingType;

  private readonly eventTrackingService = inject(EventTrackingService);

  public openSocialUrl(url: string): void {
    window.open(url, '_blank');

    this.eventTrackingService.track(
      this.noCampaignContextMode()
        ? EEventType.creatorExternalSourceOpened
        : EEventType.campaignAnalyticsExternalSourceOpened,
      { socialContentId: this.execution().socialContentId ?? undefined },
    );
  }
}
